export { default } from './SearchTitle';



// WEBPACK FOOTER //
// ./app/components/search/SearchTitle/index.js